import { jsx as _jsx } from "react/jsx-runtime";
import { Close as IconClose, Done as IconDone } from "@mui/icons-material";
import clsx from "clsx";
import { useStyles } from "./ui_icon_status.css";
export const UiIconStatus = ({ variant }) => {
    const classes = useStyles();
    if (variant === "error") {
        return (_jsx(IconClose, { className: clsx(classes.ui_icon_status, classes["ui_icon_status--error"]), color: "error" }));
    }
    if (variant === "success") {
        return (_jsx(IconDone, { className: clsx(classes.ui_icon_status, classes["ui_icon_status--success"]), color: "primary" }));
    }
    return null;
};
//# sourceMappingURL=ui_icon_status.js.map